/** @file slotEntries: the rows of an Art slot card's menu (upload, paint, clear, masks, twin, ask). */
import type { MenuEntry, SlotMenuCtx } from './registryTypes';

type Entry = MenuEntry<SlotMenuCtx>;
const twin = (c: SlotMenuCtx): string | undefined => c.slot.mirroredFrom;

/** Upload, Paint (opens the Tile tab), Clear (disabled when empty), the two mask downloads, Copy from mirrored slot, Ask the agent. */
export const SLOT_ENTRIES: Entry[] = [
  { kind: 'item', id: 'slot.upload', label: () => 'Upload…', chords: ['art.upload'], run: (c) => { c.ops.upload(); } },
  { kind: 'item', id: 'slot.paint', label: () => 'Paint', run: (c) => { c.ops.paint(); } },
  { kind: 'item', id: 'slot.clear', label: () => 'Clear', chords: ['art.clearSlot'], disabled: (c) => c.slot.status === 'empty', run: (c) => { c.ops.clear(); } },
  { kind: 'separator' },
  { kind: 'item', id: 'slot.maskSilhouette', label: () => 'Download mask (silhouette)', chords: ['art.downloadMask'], run: (c) => { c.ops.mask('silhouette'); } },
  { kind: 'item', id: 'slot.maskSkeleton', label: () => 'Download mask (skeleton)', run: (c) => { c.ops.mask('skeleton'); } },
  { kind: 'separator' },
  {
    kind: 'item', id: 'slot.copyMirrored', label: (c) => (twin(c) === undefined ? 'Copy from mirrored slot' : `Copy from mirrored slot (${twin(c) ?? ''})`),
    disabled: (c) => twin(c) === undefined || !c.mirroredFilled, run: (c) => { c.ops.copyMirrored(); },
  },
  { kind: 'item', id: 'slot.ask', label: () => 'Ask the agent to draw this', run: (c) => { c.ops.ask(); } },
];
